var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{key:_vm.editorKey,class:{'disabledStyle': _vm.disabled},attrs:{"api-key":"no-api-key","init":_vm.editorInit,"disabled":_vm.disabled},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }